import React, { DetailedHTMLProps, InputHTMLAttributes } from "react";

import classnames from "classnames";

import { useWombatTheme } from "../../theme";

type ContainerProps = {
  /**
   * Use a narrow Container layout when no sidebar is used and content is vertical (eg: reports)
   * Note: When used in conjunction with a ScreenHeader, narrow must also be set on the ScreenHeader component
   */
  narrow?: boolean;
} & DetailedHTMLProps<InputHTMLAttributes<HTMLDivElement>, HTMLDivElement>;

const Container: React.FC<React.PropsWithChildren<ContainerProps>> = ({
  children,
  className,
  narrow = false,
  ...props
}) => {
  const { theme } = useWombatTheme();
  const containerStyle = classnames(
    theme.layout.container[narrow ? "narrow" : "base"],
    className
  );

  return (
    <div className={containerStyle} {...props}>
      {children}
    </div>
  );
};

export default React.memo(Container);
